module.exports = __webpack_public_path__ + "static/media/ic_folder_open.07b8ab27.png";